var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error"},[_c('div',{staticClass:"flex jcc"},[_c('div',{staticClass:"width-80"},[_c('img',{staticClass:"m-c",attrs:{"src":require("../assets/images/404.jpg"),"alt":""}}),_c('div',{staticClass:"btn m-c shou width-fit",on:{"click":_vm.click}},[_vm._v("返回首页")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }